export const ACCORDION_GROUP_NAME: string = 'm-accordion-group';
export const ACCORDION_NAME: string = 'm-accordion';
export const ACCORDION_TRANSITION_NAME: string = 'm-accordion-transition';
export const ADD_NAME: string = 'm-add';
export const ADDRESS_AUTOCOMPLETE_FIELD_NAME: string = 'm-address-autocomplete-field';
export const ADDRESS_EDITOR_NAME: string = 'm-address-editor';
export const ADDRESS_LOOKUP_FIELD_NAME: string = 'm-address-lookup-field';
export const ADDRESS_READER: string = 'm-address-reader';
export const AUTO_HORIZONTAL_SCROLL: string = 'm-auto-horizontal-scroll';
export const AUTOCOMPLETE_NAME: string = 'm-autocomplete';
export const AVATAR_NAME: string = 'm-avatar';
export const BREADCRUMBS_NAME: string = 'm-breadcrumbs';
export const BUTTON_NAME: string = 'm-button';
export const BUTTON_GROUP_NAME: string = 'm-button-group';
export const CALENDAR_NAME: string = 'm-calendar';
export const CAROUSEL_NAME: string = 'm-carousel';
export const CAROUSEL_ITEM_NAME: string = 'm-carousel-item';
export const CHARACTER_COUNT_NAME: string = 'm-character-count';
export const CHECKBOX_NAME: string = 'm-checkbox';
export const CHIP_NAME: string = 'm-chip';
export const CHIP_ADD_NAME: string = 'm-chip-add';
export const CHIP_DELETE_NAME: string = 'm-chip-delete';
export const COPY_TO_CLIPBOARD_NAME: string = 'm-copy-to-clipboard';
export const COPY_TO_CLIPBOARD_FEEDBACK_NAME: string = 'm-copy-to-clipboard-feedback';
export const COUNTRY_FLAG_NAME: string = 'm-country-flag';
export const DATEPICKER_NAME: string = 'm-datepicker';
export const DATERANGEPICKER_NAME: string = 'm-daterangepicker';
export const DECIMALFIELD_NAME: string = 'm-decimalfield';
export const DIALOG_NAME: string = 'm-dialog';
export const DROPDOWN_NAME: string = 'm-dropdown';
export const DROPDOWN_ITEM_NAME: string = 'm-dropdown-item';
export const DYNAMIC_TEMPLATE_NAME: string = 'm-dynamic-template';
export const EMPTY_AREA_NAME: string = 'm-empty-area';
export const ERROR_ACCESS_DENIED_NAME: string = 'm-error-access-denied';
export const ERROR_BROWSER_NOT_SUPPORTED_NAME: string = 'm-error-browser-not-supported';
export const ERROR_CONFIG_NOT_SUPPORTED_NAME: string = 'm-error-config-not-supported';
export const ERROR_CONFLICT_NAME: string = 'm-error-conflict';
export const ERROR_COOKIES_NOT_SUPPORTED_NAME: string = 'm-error-cookies-not-supported';
export const ERROR_PAGE_NOT_FOUND_NAME: string = 'm-error-page-not-found';
export const ERROR_RESOURCE_UNAVAILABLE_NAME: string = 'm-error-resource-unavailable';
export const ERROR_TECHNICAL_DIFFICULTY_NAME: string = 'm-error-technical-difficulty';
export const ERROR_SESSION_EXPIRED_NAME: string = 'm-error-session-expired';
export const EXPANDABLE_LAYOUT_NAME: string = 'm-expandable-layout';
export const FILE_SELECT_NAME: string = 'm-file-select';
export const FILE_UPLOAD_NAME: string = 'm-file-upload';
export const FORM_NAME: string = 'm-form';
export const OVERLAY_NAME: string = 'm-overlay';
export const I18N_NAME: string = 'm-i18n';
export const ICON_NAME: string = 'm-icon';
export const ICON_BUTTON_NAME: string = 'm-icon-button';
export const ICON_FILE_NAME: string = 'm-icon-file';
export const INPLACE_EDIT_NAME: string = 'm-inplace-edit';
export const INPUT_GROUP_NAME: string = 'm-input-group';
export const INPUT_STYLE_NAME: string = 'm-input-style';
export const LIMIT_ELEMENTS: string = 'm-limit-elements';
export const LIMIT_TEXT_NAME: string = 'm-limit-text';
export const LINK_NAME: string = 'm-link';
export const LIST_ITEM_NAME: string = 'm-list-item';
export const MASKEDFIELD_NAME: string = 'm-maskedfield';
export const MESSAGE_NAME: string = 'm-message';
export const MENU_NAME: string = 'm-menu';
export const MENU_ITEM_NAME: string = 'm-menu-item';
export const MESSAGE_PAGE_NAME: string = 'm-message-page';
export const MONEYFIELD_NAME: string = 'm-moneyfield';
export const MODAL_NAME: string = 'm-modal';
export const MULTI_SELECT_NAME: string = 'm-multi-select';
export const NAVBAR_NAME: string = 'm-navbar';
export const NAVBAR_ITEM_NAME: string = 'm-navbar-item';
export const OPACITY_TRANSITION_NAME: string = 'm-opacity-transition';
export const OPTION_NAME: string = 'm-option';
export const OPTION_ITEM_NAME: string = 'm-option-item';
export const OPTION_ITEM_ADD_NAME: string = 'm-option-item-add';
export const OPTION_ITEM_ARCHIVE_NAME: string = 'm-option-item-archive';
export const OPTION_ITEM_DELETE_NAME: string = 'm-option-item-delete';
export const OPTION_ITEM_EDIT_NAME: string = 'm-option-item-edit';
export const OPTION_TITLE: string = 'm-option-title';
export const OPTION_SEPARATOR: string = 'm-option-separator';
export const ORGANIZE_TABLE_COLUMNS_NAME: string = 'm-organize-table-columns';
export const ORGANIZE_TABLE_COLUMNS_MODAL_NAME: string = 'm-organize-table-columns-modal';
export const PANEL_NAME: string = 'm-panel';
export const PAGINATION_NAME: string = 'm-pagination';
export const PERIODPICKER_NAME: string = 'm-periodpicker';
export const PHONEFIELD_NAME: string = 'm-phonefield';
export const PHOTO_EDITOR_NAME: string = 'm-photo-editor';
export const PLUS_NAME: string = 'm-plus';
export const POPPER_NAME: string = 'm-popper';
export const POPUP_NAME: string = 'm-popup';
export const POSTALCODEFIELD_NAME: string = 'm-postalcodefield';
export const POWERED_BY_GOOGLE: string = 'm-powered-by-google';
export const PROGRESS_NAME: string = 'm-progress';
export const RADIO_NAME: string = 'm-radio';
export const RADIO_GROUP_NAME: string = 'm-radio-group';
export const RADIO_STYLE_NAME: string = 'm-radio-style';
export const REPEATER_NAME: string = 'm-repeater';
export const RESPONSIVE_TABLE_NAME: string = 'm-responsive-table';
export const RICH_TEXT_NAME: string = 'm-rich-text';
export const RICH_TEXT_EDITOR_NAME: string = 'm-rich-text-editor';
export const SCROLL_TOP_NAME: string = 'm-scroll-top';
export const SEARCHFIELD_NAME: string = 'm-searchfield';
export const SHOW_MORE_NAME: string = 'm-show-more';
export const SIDEBAR_NAME: string = 'm-sidebar';
export const SPINNER_NAME: string = 'm-spinner';
export const SLIDE_TRANSITION_NAME: string = 'm-slide-transition';
export const STEPPERS_NAME: string = 'm-steppers';
export const STEPPERS_ITEM_NAME: string = 'm-steppers-item';
export const SWITCH_NAME: string = 'm-switch';
export const TABLE_NAME: string = 'm-table';
export const TABLE_HEAD_NAME: string = 'm-table-head';
export const TABLE_GROUP_NAME: string = 'm-table-group';
export const TABLE_GROUP_HEADER_NAME: string = 'm-table-group-header';
export const TABLE_EMPTY_ROW_NAME: string = 'm-table-empty-row';
export const TABLE_HEADER_NAME: string = 'm-table-header';
export const TEMPLATE_NAME: string = 'm-template';
export const TEXTAREA_NAME: string = 'm-textarea';
export const TEXTFIELD_NAME: string = 'm-textfield';
export const TIMEPICKER_NAME: string = 'm-timepicker';
export const TOAST: string = 'm-toast';
export const TOGGLE_BUTTONS_NAME: string = 'm-toggle-buttons';
export const TOOLTIP_NAME: string = 'm-tooltip';
export const TOUCH_NAME: string = 'm-touch';
export const TREE_NAME: string = 'm-tree';
export const TREE_ICON_NAME: string = 'm-tree-icon';
export const TREE_NAME_NODE: string = 'm-tree-node';
export const TYPEAHEAD_NAME: string = 'm-typeahead';
export const VALIDATION_MESSAGE_NAME: string = 'm-validation-message';
export const INTEGERFIELD_NAME: string = 'm-integerfield';
export const SELECT_NAME: string = 'm-select';
export const SELECT_VIRTUAL_SCROLL_NAME: string = 'm-select-virtual-scroll';
export const SVG_NAME: string = 'm-svg';
export const INPUT_MASK_NAME: string = 'm-input-mask';
export const CALENDAR_BUTTON_NAME: string = 'm-calendar-button';
